import Axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

import router from '@/router'
import {
  getAccessToken,
  hasTokenSaved,
  remove,
  getRefreshUrl,
  renewAccessToken,
} from '@/util/token'

const mouse = Axios.create({
  baseURL: process.env.VUE_APP_MOUSE_API_URL_BASE,
})

function reAuth(failedRequest) {
  return renewAccessToken().then(() => {
    const token = getAccessToken()
    failedRequest.response.config.headers['Authorization'] = `Bearer ${token}`
    return Promise.resolve()
  })
}

createAuthRefreshInterceptor(mouse, reAuth)

mouse.interceptors.request.use(async config => {
  if (!hasTokenSaved()) {
    return config
  }

  // トークンの提示が必要ないエンドポイントもあるが、ひとまず
  // クライアントにトークンが保存されていればそれを送る。
  let token = getAccessToken()

  if (!token) {
    return config
  }

  config.headers.Authorization = `Bearer ${token}`

  return config
})

mouse.interceptors.response.use(
  r => {
    // NOP
    return r
  },
  error => {
    if (error.response.config.url === getRefreshUrl()) {
      // トークンリフレッシュの失敗はもうどうしようもないのでログイン画面に移す
      remove()
      router.push('/login')
    }

    return Promise.reject(error)
  },
)

export default mouse
